module.exports = __webpack_public_path__ + "img/Morocco.8d134f44.svg";